import bearding from '@/assets/plotting/Bearding.svg?react';
import bruise from '@/assets/plotting/Bruise.svg?react';
import burn from '@/assets/plotting/Burn.svg?react';
import cavity from '@/assets/plotting/Cavity.svg?react';
import chip from '@/assets/plotting/Chip.svg?react';
import cloud from '@/assets/plotting/Cloud.svg?react';
import crystal from '@/assets/plotting/Crystal.svg?react';
import etchChannel from '@/assets/plotting/EtchChannel.svg?react';
import extraFacet from '@/assets/plotting/ExtraFacet.svg?react';
import feather from '@/assets/plotting/Feather.svg?react';
import grainCenter from '@/assets/plotting/GrainCenter.svg?react';
import indentedNatural from '@/assets/plotting/IndentedNatural.svg?react';
import internalGraining from '@/assets/plotting/InternalGraining.svg?react';
import knot from '@/assets/plotting/Knot.svg?react';
import laserDrillHole from '@/assets/plotting/LaserDrillHole.svg?react';
import lizardSkin from '@/assets/plotting/LizardSkin.svg?react';
import natural from '@/assets/plotting/Natural.svg?react';
import needle from '@/assets/plotting/Needle.svg?react';
import nick from '@/assets/plotting/Nick.svg?react';
import pinPoint from '@/assets/plotting/PinPoint.svg?react';
import pits from '@/assets/plotting/Pits.svg?react';
import polishLines from '@/assets/plotting/PolishLines.svg?react';
import surfaceGraining from '@/assets/plotting/SurfaceGraining.svg?react';
import twinningWisp from '@/assets/plotting/TwinningWisp.svg?react';
import unknown from '@/assets/plotting/Unknown.svg?react';

import { InclusionsType } from './Clarity';

export const INCLUSION_TYPES: InclusionsType[] = [
  {
    code: 'Crystal',
    img: crystal,
    title: 'Crystal',
  },
  {
    code: 'Cloud',
    img: cloud,
    title: 'Cloud',
  },
  {
    code: 'Pinpoint',
    img: pinPoint,
    title: 'Pin Point',
  },
  {
    code: 'Feather',
    img: feather,
    title: 'Feather',
  },
  {
    code: 'Needle',
    img: needle,
    title: 'Needle',
  },
  {
    code: 'Bruise',
    img: bruise,
    title: 'Bruise',
  },
  {
    code: 'Laser drill hole',
    img: laserDrillHole,
    title: 'Laser Drill Hole',
  },
  {
    code: 'Indented natural',
    img: indentedNatural,
    title: 'Indented Natural',
  },
  {
    code: 'Cavity',
    img: cavity,
    title: 'Cavity',
  },
  {
    code: 'Natural',
    img: natural,
    title: 'Natural',
  },
  {
    code: 'Chip',
    img: chip,
    title: 'Chip',
  },
  {
    code: 'Etch channel',
    img: etchChannel,
    title: 'Etch Channel',
  },
  {
    code: 'Knot',
    img: knot,
    title: 'Knot',
  },
  {
    code: 'Twinning wisp',
    img: twinningWisp,
    title: 'Twinning Wisp',
  },
  {
    code: 'Extra facet',
    img: extraFacet,
    title: 'Extra Facet',
  },
  {
    code: 'Surface graining',
    img: surfaceGraining,
    title: 'Surface Graining',
  },
  {
    code: 'Bearding',
    img: bearding,
    title: 'Bearding',
  },
  {
    code: 'Grain center',
    img: grainCenter,
    title: 'Grain Center',
  },
  {
    code: 'Internal graining',
    img: internalGraining,
    title: 'Internal Graining',
  },
  {
    code: 'Polish lines',
    img: polishLines,
    title: 'Polish Lines',
  },
  {
    code: 'Pits',
    img: pits,
    title: 'Pits',
  },
  {
    code: 'Burn',
    img: burn,
    title: 'Burn',
  },
  {
    code: 'Nick',
    img: nick,
    title: 'Nick',
  },
  {
    code: 'Lizard skin',
    img: lizardSkin,
    title: 'Lizard Skin',
  },
  {
    code: 'Unknown',
    img: unknown,
    title: 'Unknown',
  },
];
